<template>
    <div id="kfc_main_menu" class="kfc_main_menu" ref="contentRef">
        <div class="__main_content_section" :id="'category' + index" v-for="(categoryItem, index) in cats" :key="index">
            <template v-if="showSliderProduct && categoryItem.show_web === 'DT'">
                <div class="category_header">
                    <span v-if="locale == 'mn'">{{ categoryItem.category_mon }}</span>
                    <span v-if="locale == 'en'">{{ categoryItem.category_en }}</span>

                    <div v-if="showSliderProduct && categoryItem.show_web === 'DT'" class="navigation">
                        <img @click="slidePrevItem(index)" class="" src="@/assets/icons/left.svg" alt="">
                        <img @click="slideNextItem(index)" class="" src="@/assets/icons/right.svg" alt="">
                    </div>
                </div>
                <swiper :data-id="index" ref="swiperRefs" :slides-per-view="2" :space-between="10" :cssMode="true"
                    :modules="modules">
                    <swiper-slide v-for="menu in menus[categoryItem.category]" :key="menu.pkey">
                        <slot name="sliderProducts" :menuItem="menu">
                        </slot>
                    </swiper-slide>
                </swiper>
            </template>
            <template v-else>
                <div class="category_header">
                    <span v-if="locale == 'mn'">{{ categoryItem.category_mon }}</span>
                    <span v-if="locale == 'en'">{{ categoryItem.category_en }}</span>
                </div>
                <div class="__main_content_block" :class="categoryItem.show_web === 'DT' ? 'grid-item-4' : 'grid-item-3'">
                    <slot name="products" :menus="menus[categoryItem.category]" :key="menus">
                    </slot>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import Req from '@/utils/Request'
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
const props = defineProps(['showSliderProduct']);
const { showSliderProduct } = props;
const store = useStore()
const allCategories = computed(() => store.getters['menu/getAllCats'])
const cats = computed(() => store.getters['menu/getCats'])
const menus = computed(() => store.getters['menu/getMenusWuthCat'])
const order_type = computed(() => store.getters['address/getOrderType'])
const outletNameDelivery = computed(() => store.getters['address/getDeliveryOutletName'])
const pickupAddress = computed(() => store.getters['address/getPickupAddress'])
const default_menus_delivery = computed(() => store.getters['menu/getDefaultMenusDelivery'])
const default_menus_pickup = computed(() => store.getters['menu/getDefaultMenusPickup'])
const default_outlet = computed(() => store.getters['address/getDefaultOutlet'])

const contentRef = ref()
const locale = computed(() => store.getters['locale'])
const tempCats = ref([])
const swiperRefs = ref([]);
// const slidePrevRefs = ref([]);
// const slideNextRefs = ref([]);
const cart = computed(() => store.getters['cart/inCart']);

const virtualMenus = computed(() => order_type.value === 1 ? default_menus_delivery.value : default_menus_pickup.value);
onMounted(() => {
    fetchVirtualMenu().then(() => {
        fetchMenuData();
    });
});
const fetchVirtualMenu = async () => {
    const { data } = await Req({ url: '/menu/getWebMenus', body: { order_type: order_type.value, outlet_name: default_outlet.value }, hideSuccess: true })
    if (data.success) {
        if (order_type.value === 1) {
            store.dispatch('menu/setDefaultMenuDelivery', data.result.sort((a, b) => parseInt(a.menu_sort) - parseInt(b.menu_sort)))
        } else if (order_type.value === 2) {
            store.dispatch('menu/setDefaultMenuPickup', data.result.sort((a, b) => parseInt(a.menu_sort) - parseInt(b.menu_sort)))
        }
    }
}
const fetchMenuData = async () => {
    const { data } = await Req({ url: '/menu/getWebMenus', body: { order_type: order_type.value, outlet_name: order_type.value === 1 ? outletNameDelivery.value : pickupAddress.value }, hideSuccess: true })
    const currentMenu = data.result?.sort((a, b) => parseInt(a.menu_sort) - parseInt(b.menu_sort))
    if (data.success) {
        let menuWithCats = {}
        // let currentMenuMap = new Map(currentMenu.map(item => [item.pkey, item]));
        // Merge arrays
        // let resultMenu = virtualMenus.value.map(item => {
        //     if (!currentMenuMap.has(item.pkey)) {
        //         return { ...item, disabled: true };
        //     }
        //     return item;
        // });
        // currentMenu.forEach(item => {
        //     if (!resultMenu.some(existingItem => existingItem.pkey === item.pkey)) {
        //         resultMenu.push(item);
        //     }
        // });
        let resultMenu = currentMenu
        allCategories.value.forEach(element => {
            const menuWithCat = resultMenu.filter(x => x.menu_category === element.category)
            if (menuWithCat.length > 0) {
                menuWithCats[element.category] = menuWithCat;
                tempCats.value.push(element);
            }
        });
        store.dispatch('menu/setCategory', tempCats.value)
        store.dispatch('menu/setMenu', { menus: resultMenu, menuWithCat: menuWithCats })
        tempCats.value = []
        checkProducts(resultMenu)
    }
}
watch(order_type, () => {
    fetchDatas();
});
watch(outletNameDelivery, () => {
    fetchDatas();

});
watch(pickupAddress, () => {
    fetchDatas();
});
const fetchDatas = async () => {
    if (virtualMenus.value.length === 0) {
        await fetchVirtualMenu()
        fetchMenuData();
    } else {
        fetchMenuData();
    }
    store.dispatch('cart/clearCart')
    store.dispatch('order/clearOptions')
    sessionStorage.removeItem("orderForm")

}
const slidePrevItem = (index) => {
    const currSwiper = swiperRefs.value.find(swiper => parseInt(swiper.$attrs['data-id']) === index)
    currSwiper.$el.swiper.slidePrev()
}
const slideNextItem = (index) => {
    const currSwiper = swiperRefs.value.find(swiper => parseInt(swiper.$attrs['data-id']) === index)
    currSwiper.$el.swiper.slideNext()

}
const checkProducts = (menus) => {
    let parentItems = cart.value.filter(item => item.parent === 0);
    parentItems.forEach((item, index) => {
        const hasItem = menus.find(menu => menu.pkey === item.pkey)
        if (!hasItem) {
            store.dispatch('cart/removeFromCart', index);
        }
    })

}
// fetchMenuData();
// return {
//     modules: [], swiperRefs, slidePrevRefs, slideNextRefs, cats, menus, locale, order_type, contentRef, showSliderProduct, slidePrevItem, slideNextItem
// }
</script>

<style lang="scss" scoped>
.kfc_main_menu {
    display: flex;
    flex-direction: column;
    gap: 42px;

    .__main_content_section {
        .category_header {
            color: $darkMain;
            font-family: 'Oswald';
            font-size: 32px;
            font-style: normal;
            font-weight: 600;
            line-height: 42px;
            padding-bottom: 42px;

            /* 131.25% */
            text-transform: uppercase;
            display: flex;
            justify-content: space-between;

            .navigation {
                display: flex;
                gap: 10px;
            }
        }

        .__main_content_block {
            display: grid;
            width: 100%;
            gap: 12px;
        }

        .grid-item-4 {
            grid-template-columns: 1fr 1fr 1fr 1fr;

            @media (min-width: 1024px) and (max-width: 1521px) {
                grid-template-columns: 1fr 1fr 1fr;
            }

            @media (min-width: 768px) and (max-width: 1023px) {
                grid-template-columns: 1fr 1fr;
            }

            // @media (max-width: 768px) {
            //     grid-template-columns: 1fr 1fr;
            // }
        }

        .grid-item-3 {
            grid-template-columns: 1fr 1fr 1fr;

            @media (min-width: 1024px) and (max-width: 1521px) {
                grid-template-columns: 1fr 1fr;
            }

            @media (min-width: 768px) and (max-width: 1023px) {
                grid-template-columns: 1fr 1fr;
            }

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }
    }
}
</style>
